import { wrapService } from 'actions/service_wrapper.actions';
import { SUBSCRIPTION_PAYLOAD, BILLING_PAYLOAD } from 'types/payload.constants';
import {
  fetchBillingInfo,
  fetchSubscriptionInfo,
} from 'externals/_services/userSubscription.premium.service';

const a_fetchSubscriptionInfo = wrapService(fetchSubscriptionInfo, {
  name: 'fetchSubscriptionInfo',
});

const a_fetchBillingInfo = wrapService(fetchBillingInfo, {
  name: 'fetchBillingInfo',
});

function userSubscriptionPayload(
  subscription,
  subscriptionLoading,
  subscriptionError,
) {
  return {
    type: SUBSCRIPTION_PAYLOAD,
    subscription,
    subscriptionLoading,
    subscriptionError,
  };
}

function request() {
  return userSubscriptionPayload(null, true, null);
}

function __success(dialData) {
  return userSubscriptionPayload(dialData, false, null);
}

function failure(error) {
  return userSubscriptionPayload(null, false, error);
}

function billingPayload(billing, billingLoading, billingError) {
  return {
    type: BILLING_PAYLOAD,
    billing,
    billingLoading,
    billingError,
  };
}

function billingRequest() {
  return billingPayload(null, true, null);
}

function __billingSuccess(dialData) {
  return billingPayload(dialData, false, null);
}

function billingFailure(error) {
  return billingPayload(null, false, error);
}

export const getUserSubscription =
  (forceReload = false) =>
  (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state?.subscriptionInfo?.subscription && !forceReload) {
        resolve(state?.subscriptionInfo);
      } else {
        dispatch(request());
        dispatch(a_fetchSubscriptionInfo())
          .then(res => {
            dispatch(__success(res));
            resolve(res);
          })
          .catch(err => {
            dispatch(failure(err));
            reject(err);
          });
      }
    });
  };

export const getLatestBilling =
  (forceReload = false) =>
  (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state?.subscriptionInfo?.billing && !forceReload) {
        resolve(state?.subscriptionInfo);
      } else {
        dispatch(billingRequest());
        dispatch(a_fetchBillingInfo())
          .then(res => {
            dispatch(__billingSuccess(res?.billingInfo));
            resolve(res);
          })
          .catch(err => {
            dispatch(billingFailure(err));
            reject(err);
          });
      }
    });
  };
